// ========== PricingPage.jsx ==========
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';

const PricingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <a onClick={() => navigate('/')}> Back to Home</a>
        </nav>
      </header>

      <div className="content-container">
        <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
          <h1>Simple and Affordable Pricing</h1>
          <h2>We want to democratize AI and make it available to everyone</h2>
          <p>Choose the plan that's right for you</p>
        </div>

        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', marginBottom: '3rem'}}>
          <div className="content-section" style={{textAlign: 'center'}}>
            <h2 style={{justifyContent: 'center'}}>Free</h2>
            <div style={{color: 'var(--primary)' , fontSize: '3rem', fontWeight: 'bold', margin: '1rem 0'}}>$0</div>
            <p style={{marginBottom: '2rem'}}>forever</p>
            <ul style={{textAlign: 'left', listStyle: 'none', marginLeft: 0}}>
              <li> 1 Persona</li>
              <li> 4 Event Sequences</li>
              <li> 5 Daily Predictions</li>
              <li> Basic Analytics</li>
            </ul>
            <button className="btn-secondary" style={{marginTop: '2rem', width: '100%'}} onClick={() => navigate('/register')}>Get Started</button>
          </div>

          <div className="content-section" style={{textAlign: 'center', border: '3px solid var(--primary)'}}>
            <div style={{background: 'var(--buttonGradient)', color: 'white', padding: '0.5rem', borderRadius: '20px', marginBottom: '1rem', display: 'inline-block'}}>MOST POPULAR</div>
            <h2 style={{justifyContent: 'center'}}>Paid</h2>
            <div style={{color: 'var(--primary)' , fontSize: '3rem', fontWeight: 'bold', margin: '1rem 0'}}>$2.99</div>
            <p style={{marginBottom: '2rem'}}>per month</p>
            <ul style={{textAlign: 'left', listStyle: 'none', marginLeft: 0}}>
              <li> 3 Personas</li>
              <li> 6 Event Sequences</li>
              <li> 15 Daily Predictions</li>
              <li> Advanced Analytics</li>
              <li> No Ads</li>
              <li> Comprehensive Analysis report</li>
            </ul>
            <button className="btn-primary" style={{marginTop: '2rem', width: '100%'}} onClick={() => navigate('/register')}>Start Free Trial</button>
          </div>

          <div className="content-section" style={{textAlign: 'center'}}>
            <h2 style={{justifyContent: 'center'}}>Premium</h2>
            <div style={{color: 'var(--primary)' ,fontSize: '3rem', fontWeight: 'bold', margin: '1rem 0'}}>$6.99</div>
            <p style={{marginBottom: '2rem'}}>per month</p>
            <ul style={{textAlign: 'left', listStyle: 'none', marginLeft: 0}}>
              <li> 5 Personas</li>
              <li> 8 Event Sequences</li>
              <li> 25 Daily Predictions</li>
              <li> No Ads</li>
              <li> First access to new features</li>
              <li> Personalized parameters</li>
              <li> Advanced Analysis report</li>
              <li> Community Abassador</li>
              <li> Contribution to event post validation</li>

            </ul>
            <button className="btn-secondary" style={{marginTop: '2rem', width: '100%'}} onClick={() => navigate('/register')}>Start Free Trial</button>
          </div>
        </div>

        <div className="content-section">
          <h2>Frequently Asked Questions</h2>
          <h3>Can I change my plan later?</h3>
          <p>Yes! Upgrade or downgrade anytime. Changes reflect in your next billing cycle.</p>

          <h3>Is there a free trial?</h3>
          <p>Yes, We are offering a full fledge free tier that has all the features. It only has less attempts, less personas and fewer events input. AI is compute-expensive, if you need higher capacity and more accuracy it will cost</p>

          <h3>Can I cancel anytime?</h3>
          <p>Absolutely! Cancel anytime with no hidden fees.</p>
        </div>
      </div>

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PricingPage;
